<div class="report-model">
  <div class="report-model-header">
    <div class="info">
      <h3>{{ "reports.commercialRentalIncomeAssessment" | translate }}</h3>
    </div>
  </div>
  <app-report-datatable
    class="rwi-propertyDetail-table"
    [showLoader]="!rentalIncomeAreaLoading"
    [tableColumns]="rentalIncomeAreaColumns"
    [dataLength]="rentalIncomeAreaCount"
    [tableData]="rentalIncomeAreaData"
    [allowExcelDownload]="true"
    [hidePagination]="true"
    (sort)="sortData($event)"
    (excelDownload)="downloadExcel('property_details_commercial_rental_income')"
    [downloadLoading]="reportPropertyDetailService.downloadLoading['e']"
    [reportSectionTitle]="'Commercial Rental Income Assessment'"></app-report-datatable>
</div>
